// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ManagedSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ManagedSignetIcon" ref={forwardedRef} {...props}>
      <path d="M3.665 8.302C3.583 8.335 3.5 8.285 3.5 8.202h.017V6.453A.38.38 0 0 1 3.715 6.12l5.193-3.282a1.96 1.96 0 0 1 2.2 0l5.21 3.298A.36.36 0 0 1 16.5 6.453v1.749c0 .083-.083.133-.149.1l-5.425-2.449a2.09 2.09 0 0 0-1.836 0z" />
      <path d="m16.384 9.018-6.053-1a1.34 1.34 0 0 0-.629 0l-6.086 1C3.55 9.018 3.5 9.085 3.5 9.151v1.783c0 .066.05.116.116.133L9.702 12.1a1.4 1.4 0 0 0 .645 0l6.037-1.033c.066 0 .1-.067.1-.133V9.15c0-.066-.05-.116-.116-.133zM9.29 10.65a.218.218 0 0 1-.248.217L4.21 10.5c-.083 0-.132-.083-.132-.15V9.619c0-.084.066-.117.132-.134l4.83-.366c.132 0 .248.1.248.217z" />
      <path d="M3.5 11.783c0-.083.083-.133.165-.1l5.425 2.449a2.09 2.09 0 0 0 1.836 0l5.425-2.449c.066-.033.149.017.149.1v1.766a.36.36 0 0 1-.182.316l-5.21 3.298a1.96 1.96 0 0 1-2.2 0l-5.193-3.281a.37.37 0 0 1-.198-.316v-1.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ManagedSignetIcon = /* @__PURE__ */ Object.assign(
  ManagedSignetIconComponent,
  { displayName: 'ManagedSignetIcon' },
);
